<section class="power-reviews-snippet-container">
  <div class="content">
    <div
      [id]="'pwr-product-details-review-snippet-' + productNumber"
      [attr.data-cy]="'pwr-product-details-review-snippet-' + productNumber"
      (click)="scrollToRnR()"
    ></div>
  </div>
</section>
